import type { StoreState, SurveyState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Update partial survey and mark it dirty */
export const updateSurvey =
    (partialSurvey: Partial<SurveyState>) =>
    (state: StoreState): StoreState =>
        makeSurveyDirty({
            ...state,
            survey: { ...state.survey, ...partialSurvey },
        });
